import { USER_ROLES } from '../../../enum';
import { checkUserRole } from '../../../utils/roles';

export const canUpdateShippingAddress = userData => {
  return checkUserRole(userData, [USER_ROLES.COMPANY_MANAGER, USER_ROLES.COMPANY_ADMIN]);
};
